import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';

import { Currency } from 'components/_/common/currency/Currency';
import { Button } from 'components/_/common/button/Button';
import { CalendarActionTileIcon } from './CalendarActionTileIcon';
import CalendarAction from 'models/calendar/CalendarAction';

export type CalendarActionTileProps = {
	tab: string;
	action: CalendarAction;
};

export const CalendarActionTile = (props: CalendarActionTileProps) => {
	const { action, tab } = props;
	const showPoints = tab === 'active';

	return (
		<div className="col-12 col-md-8 col-lg-6 col-xl-4 mb-4 mb-sm-5">
			<div className="mx-0 mx-sm-3 h-100">
				<a href={`/panel/task/${action.calendarActionId}`}>
					<div className="tile missionList__tile rounded h-100">
						<div className="tile__front">
							<div className="p-3 pb-4 p-sm-4 d-flex flex-column justify-content-between h-100">
								<div>
									<CalendarActionTileIcon icon={action.icon} />
									<p className="fs-5 font-weight-bold text-center task-name">{action.name}</p>
								</div>
							</div>
						</div>
						{!isEmpty(action.earnings) && (
							<div className="tile__back d-none d-sm-flex flex-column fs-4">
								<div className="px-4 pt-4 pb-3 flex-grow-1">
									<CalendarActionTileIcon icon={action.icon} />
									{showPoints && (
										<>
											<p className="text-center mb-2">
												<FormattedMessage id="mission-list.content.earnings-information.task" />
											</p>
											<div className="d-flex flex-wrap justify-content-center">
												{Object.entries(action.earnings).map(([codeName, value]) => (
													<Currency
														key={codeName}
														className="mr-2"
														currency={codeName}
														value={value}
													/>
												))}
											</div>
										</>
									)}
								</div>
								<div className="task__button fs-5 text-center pt-3 pb-4 px-4">
									<Button color="interactive">
										<FormattedMessage id="mission-list.button.do" />
									</Button>
								</div>
							</div>
						)}
					</div>
				</a>
			</div>
		</div>
	);
};
